/**
 * Constants for storage keys (Cookies, LocalStorage, etc.)
 * used throughout the application.
 */
export const STORAGE_KEYS = {
    TOKEN: 'token',
    ORGANIZATION: 'organization',
    AUTH_USER: 'authUser',
    ROLES: 'roles',
} as const;
